import { render, staticRenderFns } from "./FloatBtns.vue?vue&type=template&id=1c5b7b6b&"
import script from "./FloatBtns.vue?vue&type=script&lang=js&"
export * from "./FloatBtns.vue?vue&type=script&lang=js&"
import style0 from "./FloatBtns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports